export const FANCY_NUMBERS_SET = 'ProductDetails::setFancyNumbers';
export const FANCY_NUMBERS_SET_ACTIVE = 'ProductDetails::setFancyNumbersActiveIndex';
export const TOGGLE_FANCYNUMBER = 'ProductDetails::toggleFancyNumber';
export const FANCY_NUMBERS_REQUEST = 'ProductDetails::requestFancyNumbers';

export const FANCY_NUMBERS_FAIL = 'ProductDetails::fancyNumbersRequestFailed';
